/** Prefix for custom events from the React web app (not applied in this host). */
export const WEB_APP_CUSTOM_EVENT_PREFIX = "webapp";

/** Prefix for custom events from this Outlook add-in — applied in `useAppInsights` `trackEvent` only. */
export const OUTLOOK_ADDIN_CUSTOM_EVENT_PREFIX = "addin";

/**
 * Prepends `{prefix}.` to a custom event name when the name is not already prefixed.
 * Call sites pass `TelemetryEvents.*` values **without** this segment.
 */
export function withCustomEventPrefix(name: string, prefix: string): string {
  const normalized = prefix.endsWith(".") ? prefix.slice(0, -1) : prefix;
  const withDot = `${normalized}.`;
  if (name.startsWith(withDot)) {
    return name;
  }
  return `${normalized}.${name}`;
}
